const CONSENT_KEY = 'crr-flash-consent';
const LEARNED_KEY = 'crr-flash-learned';
const DISMISS_KEY = 'crr-flash-dismissed';

export const getConsent = (): boolean =>
  localStorage.getItem(CONSENT_KEY) === 'true';

export const setConsent = (value: boolean): void =>
  localStorage.setItem(CONSENT_KEY, String(value));

export const isDismissedSession = (): boolean =>
  sessionStorage.getItem(DISMISS_KEY) === 'true';

export const dismissSession = (): void =>
  sessionStorage.setItem(DISMISS_KEY, 'true');

export const getLearned = (): Record<string, boolean> => {
  try {
    return JSON.parse(localStorage.getItem(LEARNED_KEY) || '{}');
  } catch {
    return {};
  }
};

export const toggleLearned = (id: string): Record<string, boolean> => {
  const learned = getLearned();
  if (learned[id]) {
    delete learned[id];
  } else {
    learned[id] = true;
  }
  localStorage.setItem(LEARNED_KEY, JSON.stringify(learned));
  return learned;
};

export const resetLearned = (): void =>
  localStorage.removeItem(LEARNED_KEY);
